<template>
    <div class="w-full">
        <div>
            <div v-if="section_type != 'claim' && section_type != 'cover'" class="flex flex-row">
                <div v-if="data.length > 0" data-cy="page-item-range" class="pt-2 font-semibold flex">
                    {{
                        $t('covers.table.page_range', {
                            pi_start: pageItemStart,
                            pi_end: pageItemEnd,
                            total: pagination.total,
                        })
                    }}
                </div>
                <div
                    class="mx-2 flex items-start font-semibold pt-2"
                    v-if="search_criteria && section_type != 'renew' && data.length > 0"
                >
                    ||
                </div>
                <div
                    class="pt-2 font-semibold"
                    v-if="search_criteria && section_type != 'renew'"
                    data-cy="previous-search-criteria"
                >
                    {{ $t('cia.search_form.search_criteria') }}
                    <template v-for="(value, name, index) in search_criteria" :key="index">
                        <span>
                            {{ name }}:
                            <span class="text-default-blue-green">{{ value }}</span>
                        </span>
                    </template>
                </div>
            </div>
            <div class="w-full">
                <a-table
                    data-cy="covers-list"
                    :columns="getColumns"
                    :dataSource="data"
                    :rowKey="(record) => record.id"
                    :pagination="pagination"
                    :locale="locale"
                    :loading="loading"
                    :rowSelection="rowSelect"
                    @change="handleTableChange"
                    size="middle"
                    class="ant-table-striped"
                >
                    <template #bodyCell="{ column, record, text }">
                        <template v-if="column.key === 'actions'">
                            <a-button-group>
                                <a-tooltip placement="top" :title="$t('covers.table.actions.view')">
                                    <a-button
                                        data-cy="edit-button"
                                        class="text-blue-400 hover:text-blue-400 focus:text-blue-400"
                                        @click="onTableAction(record.id, 'view')"
                                    >
                                        <FolderOpenOutlined />
                                    </a-button>
                                </a-tooltip>
                            </a-button-group>
                        </template>
                        <template v-else-if="column.key === 'cia_actions'">
                            <a-button-group>
                                <a-tooltip placement="top" :title="$t('covers.table.actions.edit')">
                                    <a-button
                                        data-cy="edit-button"
                                        @click="onTableAction(record.id, 'edit', record)"
                                        :disabled="recordsSelected"
                                    >
                                        <EditOutlined />
                                    </a-button>
                                </a-tooltip>
                                <a-tooltip placement="top" :title="$t('covers.table.actions.duplicate_fleet')">
                                    <a-button
                                        class="btn-gray"
                                        data-cy="duplicate-cover-fleet-button"
                                        @click="duplicateCover('fleet', record.id)"
                                        :disabled="disableDuplicate(record)"
                                    >
                                        <CopyOutlined />
                                    </a-button>
                                </a-tooltip>
                                <a-tooltip placement="top" :title="$t('covers.table.actions.duplicate_cover')">
                                    <a-button
                                        class="btn-gray"
                                        data-cy="duplicate-cover-cover-button"
                                        @click="duplicateCover('cover', record.id)"
                                        :disabled="disableDuplicate(record)"
                                    >
                                        <CopyOutlined />
                                    </a-button>
                                </a-tooltip>
                                <!-- <a-tooltip placement="top" :title="$t('covers.table.actions.print_preview')">
                                <a-button
                                    class="btn-gray"
                                    data-cy="print-preview-cover-button"
                                    @click="printCover(record.id, true)"
                                    :disabled="
                                        recordsSelected ||
                                        (dayjs(record.cover_expiry_date).diff(dayjs()) <= 0 &&
                                            record.cover_status == 'active') ||
                                        record.cover_status != 'active' ||
                                        !record.is_authorized
                                    "
                                >
                                    <EyeOutlined />
                                </a-button>
                            </a-tooltip> -->
                                <a-tooltip placement="top" :title="$t('covers.table.actions.print')">
                                    <a-button
                                        class="btn-gray"
                                        data-cy="print-cover-button"
                                        @click="printCover(record.id)"
                                        :disabled="
                                            recordsSelected ||
                                            (dayjs(record.cover_expiry_date).diff(dayjs()) <= 0 &&
                                                record.cover_status == 'active') ||
                                            record.cover_status != 'active' ||
                                            !record.is_authorized
                                        "
                                    >
                                        <PrinterOutlined />
                                    </a-button>
                                </a-tooltip>
                                <a-tooltip placement="top" :title="$t('covers.table.actions.cascade')">
                                    <a-button
                                        class="btn-gray"
                                        data-cy="cascade-cover-button"
                                        @click="onTableAction(record.id, 'cascade', record)"
                                        :disabled="disableCascade(record)"
                                    >
                                        <ApartmentOutlined />
                                    </a-button>
                                </a-tooltip>
                                <a-tooltip placement="top" :title="$t('covers.table.actions.cancel')">
                                    <a-button
                                        :class="record.cover_status == 'cancel' ? 'btn-gray' : 'btn-red'"
                                        data-cy="cancel-cover-button"
                                        @click="cancelCover(record.id)"
                                        :disabled="recordsSelected || record.cover_status == 'cancel'"
                                    >
                                        <StopOutlined />
                                    </a-button>
                                </a-tooltip>
                                <a-tooltip
                                    v-if="isAnAuthorizer && !record.is_authorized && record.print_count == 0"
                                    placement="top"
                                    :title="$t('covers.table.actions.authorize')"
                                >
                                    <a-button
                                        :class="'btn-green'"
                                        data-cy="authorize-cover-button"
                                        @click="authorizeCover(record.id)"
                                        :disabled="!record.can_authorize"
                                    >
                                        <CheckSquareOutlined />
                                    </a-button>
                                </a-tooltip>
                            </a-button-group>
                        </template>
                        <template v-else-if="column.key === 'select'">
                            <a-button data-cy="edit-button" type="primary" @click="onSelect(record)">
                                {{ $t('covers.table.actions.select') }}
                            </a-button>
                        </template>
                        <template v-else-if="column.key === 'association_insurer'">
                            <span class="whitespace-nowrap">
                                {{ record.association_code }} - {{ record.company_code }}
                            </span>
                        </template>
                        <template v-else-if="column.key === 'cover_date'">
                            <span class="whitespace-nowrap">
                                {{ dateFormat(text) }}
                            </span>
                        </template>
                        <template v-else-if="column.key === 'cover_id'">
                            <span v-if="!record.is_allowed">
                                {{ text }}
                            </span>
                            <router-link
                                v-if="record.is_allowed && !is_settings"
                                :to="{ name: 'view-cover', params: { id: record.id } }"
                                class="text-default-blue-green underline hover:text-highlight-blue-green whitespace-nowrap cursor-pointer"
                            >
                                {{ text }}
                            </router-link>
                            <div
                                v-if="is_settings"
                                @click="onCoverClick(record.id)"
                                class="text-default-blue-green underline hover:text-highlight-blue-green whitespace-nowrap cursor-pointer"
                            >
                                {{ text }}
                            </div>
                        </template>
                        <template v-else-if="column.key === 'cover_period'">
                            <span class="whitespace-nowrap">
                                {{ text }}
                            </span>
                        </template>
                        <template v-else-if="column.key === 'vehicle_info'">
                            <span class="whitespace-nowrap">
                                {{ textTruncate(text) }}
                            </span>
                        </template>
                        <template v-else-if="column.key === 'policyholders'">
                            <span class="whitespace-nowrap">
                                {{ textTruncate(text) }}
                            </span>
                        </template>
                        <template v-else-if="column.key === 'cover_status'">
                            <span class="font-semibold" :class="setCoverStatusClass(text, record)">
                                {{ displayCoverStatus(text, record) }}
                            </span>
                        </template>
                        <template v-else-if="column.key === 'created_by'">
                            <span class="whitespace-nowrap">
                                {{ record.created_by != null ? record.created_by : 'N/A' }}
                            </span>
                        </template>
                        <template v-else-if="column.key === 'last_updated_by'">
                            <span class="whitespace-nowrap">
                                {{ record.last_updated_by != null ? record.last_updated_by : 'N/A' }}
                            </span>
                        </template>
                        <template v-else-if="column.key === 'is_printed'">
                            <CheckCircleOutlined v-if="text == '1'" class="text-default-green" />
                            <MinusOutlined v-if="text == '0'" />
                        </template>
                        <template v-else-if="column.key === 'claims_history'">
                            <div class="text-right pr-4">
                                <span v-if="!record.is_allowed">
                                    {{ text }}
                                </span>
                                <div
                                    v-else
                                    class="text-default-blue-green underline hover:no-underline cursor-pointer"
                                    @click="showModal(record.id)"
                                >
                                    {{ text }}
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            {{ text }}
                        </template>
                    </template>
                </a-table>
                <span
                    v-if="data.length > 0 && section_type != 'cia'"
                    data-cy="page-item-range"
                    class="page-item-range flex"
                >
                    {{
                        $t('covers.table.page_range', {
                            pi_start: pageItemStart,
                            pi_end: pageItemEnd,
                            total: pagination.total,
                        })
                    }}
                    <span class="text-red-500 pl-1" v-if="showLimitTag">
                        {{
                            $t('covers.table.page_range_limit', {
                                limit: max_limit,
                            })
                        }}
                    </span>
                </span>
                <span
                    v-if="section_type == 'cia' && recordsSelected"
                    data-cy="cover-table-actions"
                    class="flex pb-2.5 -mt-12"
                >
                    <a-dropdown :trigger="['click']">
                        <a-button @click="(e) => e.preventDefault()" data-cy="btn-mass-selection">
                            {{ $t('covers.table.actions.actions') }}
                            <DownOutlined />
                        </a-button>
                        <template #overlay>
                            <a-menu @click="onActionButtons">
                                <a-menu-item
                                    key="cover_authorize"
                                    data-cy="actions-cover-authorize"
                                    :disabled="!isAnAuthorizer"
                                >
                                    {{ $t('covers.table.actions.authorize') }}
                                </a-menu-item>
                                <a-menu-item key="cover_change_cover_date" data-cy="actions-cover-change-cover-date">
                                    {{ $t('covers.table.actions.change_cover_date') }}
                                </a-menu-item>
                                <a-menu-item key="cover_print" data-cy="actions-cover-print">
                                    {{ $t('covers.table.actions.print') }}
                                </a-menu-item>
                                <!-- <a-menu-item key="cover_print_preview" data-cy="actions-cover-print-preview">
                                {{ $t('covers.table.actions.print_preview') }}
                            </a-menu-item> -->
                                <a-menu-item
                                    key="cover_duplicate_fleet"
                                    data-cy="actions-cover-duplicate-fleet"
                                    :disabled="isAdminRole"
                                >
                                    {{ $t('covers.table.actions.duplicate_fleet') }}
                                </a-menu-item>
                                <a-menu-item
                                    key="cover_duplicate-cover"
                                    data-cy="actions-cover-duplicate-cover"
                                    :disabled="isAdminRole"
                                >
                                    {{ $t('covers.table.actions.duplicate_cover') }}
                                </a-menu-item>
                                <a-menu-item key="cover_renew" data-cy="actions-cover-renew" :disabled="isAdminRole">
                                    {{ $t('covers.table.actions.renew') }}
                                </a-menu-item>
                                <a-menu-item key="cover_cancel" data-cy="actions-cover-cancel">
                                    {{ $t('covers.table.actions.cancel') }}
                                </a-menu-item>
                            </a-menu>
                        </template>
                    </a-dropdown>
                </span>
            </div>
        </div>
        <modal-claims :cover_id="cover_id" ref="ClaimsModal" />
        <modal-change-date ref="ModalChangeDate" :loading="loading" @submitCoverDate="handleCoverDateChange" />
    </div>
</template>

<script>
import ModalClaims from '@/components/modals/Claims.vue';
import ModalChangeDate from '@/components/modals/ChangeCoverDate.vue';
import {
    ApartmentOutlined,
    CheckCircleOutlined,
    CheckSquareOutlined,
    CopyOutlined,
    DownOutlined,
    EditOutlined,
    EyeOutlined,
    FolderOpenOutlined,
    MinusOutlined,
    PrinterOutlined,
    StopOutlined,
} from '@ant-design/icons-vue';

export default {
    components: {
        ModalClaims,
        ModalChangeDate,
        ApartmentOutlined,
        CheckCircleOutlined,
        CheckSquareOutlined,
        CopyOutlined,
        DownOutlined,
        EditOutlined,
        EyeOutlined,
        FolderOpenOutlined,
        MinusOutlined,
        PrinterOutlined,
        StopOutlined,
    },
    props: {
        search_criteria: {
            type: Object,
            default: () => {},
        },
        section_type: {
            type: String,
            default: '',
        },
        association_id: {
            type: String,
            default: '',
        },
        company_id: {
            type: String,
            default: '',
        },
        is_settings: {
            type: Boolean,
            default: false,
        },
        setting_section: {
            type: String,
            default: '',
        },
        claim_id: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            cover_id: null,
            search_id: '',
            data: [],
            pagination: {
                pageSize: 10,
                showSizeChanger: false,
                total: 0,
            },
            locale: {
                emptyText: this.$t('covers.table.no_data'),
            },
            loading: false,
            current_filter: {},
            sorter: {},
            params: {},
            selected_row_keys: [],
            search_motor_count: 0,
            search_non_motor_count: 0,
            select_all_covers: false,
            processing: false,
            max_limit: 0,
            validation: {
                errors: {},
                message: '',
            },
        };
    },
    mounted() {
        if (this.section_type != 'cia') {
            this.fetch();
        }
    },
    computed: {
        isClaimsVaultEnabled() {
            return this.$store.state.user.modules.claimsvault;
        },
        isAdminRole() {
            return (
                this.$store.state.user.abilities.includes('manage-association') ||
                this.$store.state.user.abilities.includes('manage-admin')
            );
        },
        getColumns() {
            let columns = [];

            if (this.section_type == 'cia') {
                columns = [
                    {
                        title: () => {
                            if (this.select_all_covers) {
                                return this.$t('covers.table.headers.selected_count') + this.pagination.total;
                            } else {
                                if (this.selected_row_keys.length > 0) {
                                    return (
                                        this.$t('covers.table.headers.selected_count') + this.selected_row_keys.length
                                    );
                                } else {
                                    return '';
                                }
                            }
                        },
                        key: 'cia_actions',
                        width: 70,
                    },
                    {
                        title: this.$t('covers.table.headers.type_of_cover'),
                        key: 'cover_type',
                        dataIndex: 'cover_type',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.insurer_policy_number'),
                        key: 'insurer_policy_number',
                        dataIndex: 'insurer_policy_number',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.chassis_number'),
                        key: 'chassis_number',
                        dataIndex: 'chassis_number',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.vehicle_make'),
                        key: 'vehicle_make',
                        dataIndex: 'vehicle_make',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.vehicle_model'),
                        key: 'vehicle_model',
                        dataIndex: 'vehicle_model',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.reg_no'),
                        key: 'registration_number',
                        dataIndex: 'registration_number',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.cover_effective_date'),
                        key: 'cover_date',
                        dataIndex: 'cover_effective_date',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.cover_expiry_date'),
                        key: 'cover_date',
                        dataIndex: 'cover_expiry_date',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.status'),
                        key: 'cover_status',
                        dataIndex: 'cover_status',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.is_printed'),
                        key: 'is_printed',
                        dataIndex: 'is_printed',
                        sorter: false,
                    },
                    {
                        title: this.$t('covers.table.headers.created_by'),
                        key: 'created_by',
                        dataIndex: 'created_by',
                        sorter: false,
                    },
                    {
                        title: this.$t('covers.table.headers.last_updated_by'),
                        key: 'last_updated_by',
                        dataIndex: 'last_updated_by',
                        sorter: false,
                    },
                ];

                if (this.setting_section == 'site_admin') {
                    columns.splice(
                        1,
                        0,
                        {
                            title: this.$t('covers.table.headers.association_insurer'),
                            key: 'association_insurer',
                            dataIndex: 'association_insurer',
                            sorter: true,
                        },
                        {
                            title: this.$t('covers.table.headers.intermediary'),
                            key: 'intermediary_name',
                            dataIndex: 'intermediary_name',
                            sorter: true,
                        },
                    );
                } else {
                    columns.splice(1, 0, {
                        title: this.$t('covers.table.headers.insurer'),
                        key: 'company_code',
                        dataIndex: 'company_code',
                        sorter: true,
                    });
                }
            } else if (this.section_type == 'renew') {
                columns = [
                    {
                        title: this.$t('covers.table.headers.insurer_policy_number'),
                        key: 'insurer_policy_number',
                        dataIndex: 'insurer_policy_number',
                    },
                    {
                        title: this.$t('covers.table.headers.company_name'),
                        key: 'name',
                        dataIndex: 'name',
                    },
                    {
                        title: this.$t('covers.table.headers.intermediary'),
                        key: 'intermediary_name',
                        dataIndex: 'intermediary_name',
                    },
                    {
                        title: this.$t('covers.table.headers.insured'),
                        key: 'policyholders',
                        dataIndex: 'policyholders',
                    },
                    {
                        title: this.$t('covers.table.headers.cover_expiry_date'),
                        key: 'cover_date',
                        dataIndex: 'cover_expiry_date',
                    },
                    {
                        key: 'select',
                        width: 70,
                    },
                ];
            } else if (this.setting_section == 'site_admin') {
                columns = [
                    {
                        title: this.$t('covers.table.headers.cover_type'),
                        key: 'cover_type',
                        dataIndex: 'cover_type',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.cover_id'),
                        key: 'cover_id',
                        dataIndex: 'cover_id',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.association_insurer'),
                        key: 'association_insurer',
                        dataIndex: 'association_insurer',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.intermediary'),
                        key: 'intermediary_name',
                        dataIndex: 'intermediary_name',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.cover_period'),
                        key: 'cover_period',
                        dataIndex: 'cover_period',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.registration_number'),
                        key: 'registration_number',
                        dataIndex: 'registration_number',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.vehicle_info'),
                        key: 'vehicle_info',
                        dataIndex: 'vehicle_info',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.chassis_number'),
                        key: 'chassis_number',
                        dataIndex: 'chassis_number',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.engine_number'),
                        key: 'engine_number',
                        dataIndex: 'engine_number',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.policyholders'),
                        key: 'policyholders',
                        dataIndex: 'policyholders',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.status'),
                        key: 'cover_status',
                        dataIndex: 'cover_status',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.claims_history'),
                        key: 'claims_history',
                        dataIndex: 'claims_history',
                        sorter: true,
                    },
                ];
            } else {
                columns = [
                    {
                        title: this.$t('covers.table.headers.cover_type'),
                        key: 'cover_type',
                        dataIndex: 'cover_type',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.cover_id'),
                        key: 'cover_id',
                        dataIndex: 'cover_id',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.insurer'),
                        key: 'company_code',
                        dataIndex: 'company_code',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.cover_period'),
                        key: 'cover_period',
                        dataIndex: 'cover_period',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.registration_number'),
                        key: 'registration_number',
                        dataIndex: 'registration_number',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.vehicle_info'),
                        key: 'vehicle_info',
                        dataIndex: 'vehicle_info',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.chassis_number'),
                        key: 'chassis_number',
                        dataIndex: 'chassis_number',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.engine_number'),
                        key: 'engine_number',
                        dataIndex: 'engine_number',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.policyholders'),
                        key: 'policyholders',
                        dataIndex: 'policyholders',
                        sorter: true,
                    },
                    {
                        title: this.$t('covers.table.headers.status'),
                        key: 'cover_status',
                        dataIndex: 'cover_status',
                        sorter: true,
                    },
                ];
                if (this.$store.state.user.modules.claimsvault) {
                    columns.push({
                        title: this.$t('covers.table.headers.claims_history'),
                        key: 'claims_history',
                        dataIndex: 'claims_history',
                        sorter: true,
                    });
                }
            }

            return columns;
        },
        pageItemStart() {
            let current_page = this.pagination.current;

            if (current_page === undefined) current_page = 1;

            return (current_page - 1) * this.pagination.pageSize + 1;
        },
        pageItemEnd() {
            let current_page = this.pagination.current,
                page_item_end = 0;

            if (current_page === undefined) current_page = 1;

            page_item_end = current_page * this.pagination.pageSize;

            if (this.pagination.total !== undefined && this.pagination.total < page_item_end) {
                return this.pagination.total;
            } else {
                return page_item_end;
            }
        },
        showLimitTag() {
            return this.pagination.total !== undefined && this.max_limit > 0 && this.pagination.total > this.max_limit;
        },
        recordsSelected() {
            return this.selected_row_keys.length >= 1;
        },
        rowSelect() {
            if (this.section_type == 'cia') {
                return {
                    selectedRowKeys: this.selected_row_keys,
                    onChange: this.onSelectChange,
                    selections: this.selections,
                };
            } else {
                return null;
            }
        },
        selections() {
            return [
                {
                    key: 'all-data',
                    text: this.select_all_covers ? 'Unselect All Total Covers' : 'Select All Total Covers',
                    onSelect: (changableRowKeys) => {
                        this.select_all_covers = !this.select_all_covers;
                        let updated_selected_rows = [];
                        if (this.select_all_covers) {
                            if (this.data.length != 0) {
                                this.data.forEach((record) => {
                                    updated_selected_rows.push(record.id);
                                });
                            }
                            this.selected_row_keys = updated_selected_rows;
                            this.$emit('onSelectChange', updated_selected_rows);
                        } else {
                            this.selected_row_keys = [];
                            this.$emit('onSelectChange', []);
                        }
                    },
                },
            ];
        },
        isAnAuthorizer() {
            return this.$store.state.user.abilities.includes('authorize-covers');
        },
    },
    methods: {
        handleTableChange(pagination, filters, sorter) {
            const pager = { ...this.pagination };

            pager.current = pagination.current;

            this.pagination = pager;
            this.current_filter = filters;
            this.sorter = sorter;

            this.fetch({
                ...this.params,
                results: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },
        fetch(params = {}, search_id = '') {
            if (search_id !== '') {
                this.search_id = search_id;
            }

            this.loading = true;
            this.params = params;

            this.fetchData();
        },
        clear() {
            this.search_id = '';
            this.select_all_covers = false;
            this.onSelectChange([]);
            this.fetch();
        },
        fetchData() {
            let params = this.params;
            let id = '';

            if (this.$store.getters['user/isMultiAssociation']) {
                params.association_id = this.$store.getters['user/currentAssociationId'];
                params.company_id = this.$store.getters['user/currentCompanyId'];
            }

            if (this.association_id != '') {
                params.association_id = this.association_id;
            }

            if (this.company_id != '') {
                params.company_id = this.company_id;
            }

            let $url = '/api/covers/search';
            if (this.is_settings) {
                if (this.company_id != '') {
                    $url = '/api/companies/covers/search';
                } else {
                    $url = '/api/admin/covers/search';
                }
            }

            switch (this.section_type) {
                case 'claim':
                    this.processAll([
                        this.$http.get('/api/covers/get-by-claim/' + this.claim_id, {
                            params: params,
                        }),
                        this.$http.get('/api/covers/get-by-claim/search-count/' + this.claim_id, {
                            params: params,
                        }),
                    ]);
                    break;
                case 'cia':
                    if (this.search_id == '') {
                        this.processSplit($url + '/all', $url + '-count/all', params);
                    } else {
                        this.processAll([
                            this.$http.get($url + '/' + this.search_id, {
                                params: params,
                            }),
                            this.$http.get($url + '-count/' + this.search_id, {
                                params: params,
                            }),
                        ]);
                    }
                    break;
                case 'renew':
                    this.$http
                        .get('/api/covers/renew-search', { params: params })
                        .then((response) => {
                            const pagination = { ...this.pagination };

                            // Read total count from server
                            pagination.total = response.data.meta.total_count;

                            this.data = response.data.data;
                            this.pagination = pagination;

                            this.$emit('fetchSearchCount', {
                                search_count: pagination.total,
                            });

                            this.$emit('clear', false);
                        })
                        .catch((error) => {
                            if (error.response.status == 403) {
                                this.$notification.error({
                                    message: this.$t('globals.global.notifications.error.403_mod'),
                                });
                            } else {
                                this.$notification.error({
                                    message: this.$t('globals.global.notifications.error.any', { code: 'CVCLMF04' }),
                                });
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                    break;
                default:
                    if (this.is_settings) {
                        id = this.search_id == '' ? 'all' : this.search_id;
                    } else {
                        if (this.search_id == '') {
                            return;
                        } else {
                            id = this.search_id;
                        }
                    }

                    this.processAll([
                        this.$http.get($url + '/' + id, {
                            params: params,
                        }),
                        this.$http.get($url + '-count/' + id, {
                            params: params,
                        }),
                    ]);
                    break;
            }
        },
        processAll(urls) {
            this.$http
                .all(urls)
                .then(
                    this.$http.spread((response, count) => {
                        const pagination = { ...this.pagination };

                        // Read total count from server
                        pagination.total = count.data.meta.total_count;

                        this.data = response.data.data;
                        this.pagination = pagination;
                        this.max_limit = count.data.meta.max_limit;

                        let search_criteria = {};

                        if (response.data.search_criteria !== null) {
                            search_criteria = response.data.search_criteria;
                        }

                        this.$emit('fetchSearchCriteria', {
                            search_criteria: search_criteria,
                        });

                        this.$emit('fetchSearchCount', {
                            search_count: pagination.total,
                        });

                        this.$emit('clear', false);
                    }),
                )
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCLMF01' }),
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        processSplit(search_url, count_url, params) {
            this.$http
                .get(search_url, { params: params })
                .then((response) => {
                    let search_criteria = {};

                    this.data = response.data.data;

                    if (response.data.search_criteria !== null) {
                        search_criteria = response.data.search_criteria;
                    }

                    this.$emit('fetchSearchCriteria', {
                        search_criteria: search_criteria,
                    });

                    this.$emit('clear', false);
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCLMF02' }),
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });

            this.$http
                .get(count_url, { params: params })
                .then((count) => {
                    const pagination = { ...this.pagination };

                    // Read total count from server
                    pagination.total = count.data.meta.total_count;

                    this.pagination = pagination;
                    this.max_limit = count.data.meta.max_limit;

                    this.$emit('fetchSearchCount', {
                        search_count: pagination.total,
                    });
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCLMF03' }),
                        });
                    }
                });
        },
        setCoverStatusClass(text, record) {
            const now = this.$dayjs();
            const expiry = this.$dayjs(
                record.cover_expiry_date +
                    (this.section_type == 'cia' && !_.isEmpty(record.cover_expiry_time)
                        ? ' ' + record.cover_expiry_time
                        : ''),
            );

            return text != null
                ? text.toLowerCase() == 'active'
                    ? (expiry.diff(now) < 0 && this.section_type == 'cia') ||
                      (this.section_type != 'cia' && this.$dayjs(record.cover_period.split(' - ')[1]).diff(now) < 0)
                        ? 'text-default-gray'
                        : 'text-default-green'
                    : 'text-default-red'
                : expiry.diff(now) < 0
                  ? 'text-default-gray'
                  : 'text-default-green';
        },
        displayCoverStatus(text, record) {
            const now = this.$dayjs();
            const expiry = this.$dayjs(
                record.cover_expiry_date +
                    (this.section_type == 'cia' && !_.isEmpty(record.cover_expiry_time)
                        ? ' ' + record.cover_expiry_time
                        : ''),
            );

            return text != null
                ? text.toLowerCase() == 'active'
                    ? (expiry.diff(now) < 0 && this.section_type == 'cia') ||
                      (this.section_type != 'cia' && this.$dayjs(record.cover_period.split(' - ')[1]).diff(now) < 0)
                        ? this.$t('covers.status.expired').toUpperCase()
                        : this.$t('covers.status.active').toUpperCase()
                    : this.$t('covers.status.cancelled').toUpperCase()
                : expiry.diff(now) < 0
                  ? this.$t('covers.status.expired').toUpperCase()
                  : this.$t('covers.status.active').toUpperCase();
        },
        dateFormat(date) {
            return this.$dayjs(date).format('MMMM DD, YYYY');
        },
        textTruncate(string) {
            if (string == null) {
                return '';
            }
            if (string.length > 20) {
                return string.substring(0, 20) + '...';
            }
            return string;
        },
        dateFormat(date) {
            return this.$dayjs(date).format('MMMM DD, YYYY');
        },
        disableCascade(record) {
            return (
                this.recordsSelected ||
                (this.$dayjs(record.cover_expiry_date).diff(this.$dayjs()) <= 0 && record.cover_status == 'active') ||
                record.print_count > 0 ||
                record.cover_status != 'active' ||
                record.record_count == 0 ||
                this.isAdminRole // no association/site admin role should be able to cascade
            );
        },
        disableDuplicate(record) {
            return (
                this.recordsSelected ||
                (this.$dayjs(record.cover_expiry_date).diff(this.$dayjs()) <= 0 && record.cover_status == 'active') ||
                record.cover_status != 'active' ||
                this.isAdminRole // no association/site admin role should be able to cascade
            );
        },
        showModal(cover_id) {
            if (this.isClaimsVaultEnabled) {
                this.cover_id = cover_id;
                this.$refs.ClaimsModal.showModal();
            }
        },
        onSelectChange(selected_row_keys, selected_rows) {
            if (this.select_all_covers) {
                this.select_all_covers = false;
                this.selected_row_keys = [];
                this.$emit('onSelectChange', []);
            } else {
                this.selected_row_keys = selected_row_keys;
                this.$emit('onSelectChange', selected_row_keys);
            }
        },
        onSelect(data) {
            this.$emit('handleSelect', {
                policy_number: data.insurer_policy_number,
                registration_number: data.registration_number,
            });
        },
        onCoverClick(id) {
            this.$emit('onCoverClick', id);
        },
        renewCover() {
            if (this.selected_row_keys.length >= 1) {
                this.loading = true;
                const data = {
                    ids: this.selected_row_keys,
                };

                this.$http
                    .post('/api/covers/renew-covers', data)
                    .then((response) => {
                        if (response.data.status == 'success') {
                            this.reload();

                            this.$notification.success({
                                message: response.data.message,
                            });
                        } else {
                            this.$notification.error({
                                message: response.data.message,
                            });
                        }
                    })
                    .catch(() => {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCS06' }),
                        });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        changeCoverDate() {
            this.$refs.ModalChangeDate.openModal();
        },
        handleCoverDateChange(dates) {
            const data = {
                ids: [],
                effective_date: dates.start_date,
                expiry_date: dates.end_date,
            };

            if (this.selected_row_keys.length >= 1) {
                data.ids = this.selected_row_keys;
                this.loading = true;

                this.$http
                    .post('/api/covers/change-cover-date', data)
                    .then((response) => {
                        if (response.data.status == 'success') {
                            this.selected_row_keys = [];
                            this.onSelectChange([]);
                            this.reload();
                            this.$notification.success({
                                message: response.data.message,
                            });
                        } else {
                            this.$notification.error({
                                message: response.data.message,
                            });
                        }
                    })
                    .catch(() => {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCS07' }),
                        });
                    })
                    .finally(() => {
                        this.$refs.ModalChangeDate.hideModal();
                        this.loading = false;
                    });
            }
        },
        cancelCover(cover_id = '') {
            let data = {
                ...this.params,
                ids: [],
            };

            if (cover_id !== '' && cover_id !== undefined) {
                data.ids = [cover_id];
            } else if (this.selected_row_keys.length >= 1) {
                data.ids = this.selected_row_keys;
            }

            if (data.ids.length >= 1) {
                this.loading = true;

                this.$http
                    .post('/api/covers/cancel', data)
                    .then((response) => {
                        if (response.data.status == 'success') {
                            this.select_all_covers = false;
                            this.onSelectChange([]);
                            this.fetch();

                            this.$notification.success({
                                message: response.data.message,
                            });
                        } else {
                            this.$notification.error({
                                message: response.data.message,
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVCS01' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.$notification.error({
                    message: this.$t('covers.notifications.error.select_one_or_more'),
                });
            }
        },
        authorizeCover(cover_id = '') {
            let data = {
                ...this.params,
                ids: [],
            };

            if (cover_id !== '' && cover_id !== undefined) {
                data.ids = [cover_id];
            } else if (this.selected_row_keys.length >= 1) {
                data.ids = this.selected_row_keys;
            }

            if (data.ids.length >= 1) {
                this.loading = true;

                this.$http
                    .post('/api/covers/authorize', data)
                    .then((response) => {
                        if (response.data.status == 'success') {
                            this.fetch();

                            this.$notification.success({
                                message: response.data.message,
                            });
                        } else {
                            this.$notification.error({
                                message: response.data.message,
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVDC01' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.$notification.error({
                    message: this.$t('covers.notifications.error.select_one_or_more'),
                });
            }
        },
        duplicateCover(type = 'fleet', cover_id = '') {
            let url = null;

            if (cover_id == '' || cover_id == null) {
                let data = {
                    ...this.params,
                    ids: [],
                };

                if (cover_id !== '' && cover_id !== undefined) {
                    data.ids = [cover_id];
                } else if (this.selected_row_keys.length >= 1) {
                    data.ids = this.selected_row_keys;
                }

                if (data.ids.length < 1) {
                    this.$notification.error({
                        message: this.$t('covers.notifications.error.select_one_or_more'),
                    });

                    return false;
                }

                if (type == 'cover') {
                    url = '/api/covers/duplicate-cover';
                } else {
                    url = '/api/covers/duplicate-fleet';
                }

                this.loading = true;

                this.$http
                    .post(url, data)
                    .then((response) => {
                        if (response.data.status == 'success') {
                            this.fetch();

                            this.$notification.success({
                                message: response.data.message,
                            });
                        } else {
                            this.$notification.error({
                                message: response.data.message,
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVDC02' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                if (type == 'cover') {
                    url = '/api/covers/' + cover_id + '/duplicate-cover';
                } else {
                    url = '/api/covers/' + cover_id + '/duplicate-fleet';
                }

                this.loading = true;

                this.$http
                    .post(url)
                    .then((response) => {
                        if (response.data.status == 'success') {
                            this.fetch();

                            this.$notification.success({
                                message: response.data.message,
                            });
                        } else {
                            this.$notification.error({
                                message: response.data.message,
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVDC03' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        onActionButtons(event) {
            switch (event.key) {
                case 'cover_change_cover_date':
                    this.changeCoverDate();
                    break;
                case 'cover_print':
                    this.printCovers();
                    break;
                case 'cover_print_preview':
                    this.printCovers(true);
                    break;
                case 'cover_duplicate_fleet':
                    this.duplicateCover('fleet');
                    break;
                case 'cover_duplicate-cover':
                    this.duplicateCover('cover');
                    break;
                case 'cover_authorize':
                    this.authorizeCover();
                    break;
                case 'cover_cancel':
                    this.cancelCover();
                    break;
                case 'cover_renew':
                    this.renewCover();
                    break;
            }
        },
        onTableAction(id, key, record = {}) {
            this.$emit('onTableAction', {
                id: id,
                key: key,
                data: record,
            });
        },
        reload() {
            const filters = this.current_filter;
            this.select_all_covers = false;
            this.onSelectChange([]);

            this.fetch({
                ...this.params,
                results: this.pagination.pageSize,
                page: this.pagination.current,
                sortField: this.sorter.field,
                sortOrder: this.sorter.order,
                ...filters,
            });
        },
        printCovers(is_preview = false) {
            let data = {
                ...this.params,
                ids: [],
            };

            if (this.selected_row_keys.length < 1) {
                this.$notification.error({
                    message: this.$t('covers.notifications.error.select_one_or_more'),
                });
            } else {
                data.ids = this.selected_row_keys;
                this.loading = true;

                let $url = '/api/covers/print';

                if (is_preview) {
                    $url = '/api/covers/print-preview';
                }

                this.$http
                    .post($url, data)
                    .then((response) => {
                        if (response.data.status == 'success') {
                            this.fetch();

                            this.$notification.success({
                                message: response.data.message,
                            });

                            this.downloadReport(response.data.file_path, response.data.file_name);
                        } else {
                            this.$notification.error({
                                message: response.data.message,
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVPC01' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        printCover(cover_id, is_preview = false) {
            if (cover_id === '' || cover_id === null || cover_id === undefined) {
                return false;
            }

            this.loading = true;

            let $url = '/api/covers/' + cover_id + '/generate';

            if (is_preview) {
                $url = '/api/covers/' + cover_id + '/generate-preview';
            }

            this.$http
                .post($url)
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.fetch();

                        this.$notification.success({
                            message: response.data.message,
                        });

                        this.downloadReport(response.data.file_path, response.data.file_name);
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVPC02' }),
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        downloadReport(file_path, file_name) {
            this.$http
                .get(file_path, { responseType: 'arraybuffer' })
                .then((response) => {
                    let blob = new Blob([response.data], { type: response.headers['content-type'] });
                    let link = document.createElement('a');

                    link.href = window.URL.createObjectURL(blob);
                    link.download = file_name;

                    link.click();
                })
                .catch((error) => {
                    // was not able to download file
                    console.log(error);
                });
        },
        dayjs: function (date) {
            return this.$dayjs(date);
        },
    },
};
</script>
